import { c as _c } from "react/compiler-runtime";
// Tremor Raw Slider [v0.0.0]
import * as SliderPrimitives from "@radix-ui/react-slider";
import React from "react";
import { cx, focusRing } from "@/lib/tailwind-utils";
const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitives.Root>, React.ComponentPropsWithoutRef<typeof SliderPrimitives.Root> & {
  showValue?: boolean;
}>((t0, ref) => {
  const $ = _c(22);
  let ariaLabel;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      showValue: t1,
      "aria-label": ariaLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    ariaLabel = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showValue = t1 === undefined ? true : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cx("relative flex w-full touch-none select-none items-center", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SliderPrimitives.Track className={cx("relative h-2 w-full grow overflow-hidden rounded-full bg-muted")}><SliderPrimitives.Range className="absolute h-full bg-primary/70" /></SliderPrimitives.Track>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cx("block h-5 w-7 rounded-full border-2 border-primary/80 bg-background/80 backdrop-blur-sm transition-colors", "focus-visible:outline-none", focusRing);
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== ariaLabel) {
    t5 = <SliderPrimitives.Thumb aria-label={ariaLabel} className={t4} />;
    $[9] = ariaLabel;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== ref || $[13] !== t2 || $[14] !== t5) {
    t6 = <SliderPrimitives.Root ref={ref} className={t2} {...props}>{t3}{t5}</SliderPrimitives.Root>;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== props || $[17] !== showValue) {
    t7 = showValue && <div className="min-w-[32px] text-body">{props.value ? Array.isArray(props.value) ? props.value[0] : props.value : 0}</div>;
    $[16] = props;
    $[17] = showValue;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex items-center space-x-2">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
});
Slider.displayName = SliderPrimitives.Root.displayName;
export default Slider;